<template>
  <section class="kmutt-content" :style="{ backgroundImage: `url(/${this.$staticPath}/${this.data.background})`}">
    <div class="container">
      <div class="row">
        <div class="col-12 heading">
          <h1><strong>{{data.header}}</strong></h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-box px-5">
          <div v-for="(item, index) in data.list" :key="index">
            <h3 class="text-center"><b v-html="item.header"></b></h3>
            <p v-for="(text, pIndex) in item.detail" :key="pIndex" v-html="text"></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['data']
}
</script>

<style scoped>
  @import url('../../../static/css/home-style/content.css');
</style>



// WEBPACK FOOTER //
// src/components/HOME/Content.vue